import { render, staticRenderFns } from "./ThumbsDownIcon.vue?vue&type=template&id=76093287&"
import script from "./ThumbsDownIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ThumbsDownIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports